export default __webpack_public_path__ + "static/media/asset_dark.6d015717.png";